import { render } from "./IconLogoTapi.vue?vue&type=template&id=67a21183&scoped=true&ts=true"
import script from "./IconLogoTapi.vue?vue&type=script&lang=ts"
export * from "./IconLogoTapi.vue?vue&type=script&lang=ts"

import "./IconLogoTapi.vue?vue&type=style&index=0&id=67a21183&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a21183"]])

export default __exports__